export const graphReducer = (draft, action) => {
    switch (action.type) {

        case '2d_graph': {
            draft.plateId = action.plateId;
            draft.wellId = action.wellId;
            return;
        }

        case 'Amplitude2D': {
            draft.graphType = action.graphType;
            draft.amplitude2D = action.amplitude2D;
            draft.amplitude1D = false;
            return;
        }

        case 'Amplitude1D': {
            draft.graphType = action.graphType;
            draft.amplitude1D = action.amplitude1D;
            draft.amplitude2D = false;
            return;
        }

        case 'Ch1': {

            draft.channel = "Ch1";
            draft.xChannel = action.xChannel;
            draft.yChannel = action.yChannel;
            draft.channelData = action.payload;
            return;
        }

        case 'Ch2': {

            draft.channel = "Ch2";
            draft.xChannel = action.xChannel;
            draft.yChannel = action.yChannel;
            draft.channelData = action.payload;
            return;
        }

        case 'Ch3': {

            draft.channel = "Ch3";
            draft.xChannel = action.xChannel;
            draft.yChannel = action.yChannel;
            draft.channelData = action.payload;
            return;
        }

        case 'Ch4': {

            draft.channel = "Ch4";
            draft.xChannel = action.xChannel;
            draft.yChannel = action.yChannel;
            draft.channelData = action.payload;
            return;
        }

        case 'Ch5': {

            draft.channel = "Ch5";
            draft.xChannel = action.xChannel;
            draft.yChannel = action.yChannel;
            draft.channelData = action.payload;
            return;
        }
        case 'Ch6': {

            draft.channel = "Ch6";
            draft.xChannel = action.xChannel;
            draft.yChannel = action.yChannel;
            draft.channelData = action.payload;
            return;
        }

        case 'EventFreq': {
            draft.graphType = "Event Frequency";
            draft.amplitude1D = false;
            draft.amplitude2D = false;
            return;
        }

        case 'EventSpace': {
            draft.graphType = "Event Spacing Distribution";
            draft.amplitude1D = false;
            draft.amplitude2D = false;
            return;
        }

        case 'TempCorr': {
            draft.graphType = "Temporal Correlation";
            draft.amplitude1D = false;
            draft.amplitude2D = false;
            return;
        }

        case 'CorrDist': {
            draft.graphType = "Correlation Distribution ";
            draft.amplitude1D = false;
            draft.amplitude2D = false;
            return;
        }

        case 'Galaxy': {
            draft.graphType = "Galaxy";
            draft.amplitude1D = false;
            draft.amplitude2D = false;
            return;
        }

        case 'TemporalWidth': {
            draft.graphType = "Temporal Width";
            draft.amplitude1D = false;
            draft.amplitude2D = false;
            return;
        }

        case 'WidthDist': {
            draft.graphType = "Width Distribution";
            draft.amplitude1D = false;
            draft.amplitude2D = false;
            return;
        }

        default: return null;

    }

}
